/* eslint-disable @typescript-eslint/camelcase */
import React from 'react';
import { connect } from 'react-redux';
import { Grid } from '@material-ui/core';
import AppButton from 'components/Button';
import i18n from 'i18n';
import ApplicationState from 'store/interfaces';
import { getInstanceObservabilityRequest } from 'modules/environments/actions';
import { InstanceObservabilityState } from 'modules/environments/interfaces';

interface OwnProps {
  instanceUuid: string;
  onClose: () => void;
}

interface StateProps {
  instanceObservability: InstanceObservabilityState;
}

interface DispatchProps {
  getInstanceObservabilityRequest: (payload: {
    instanceUuid: string;
    preserveExisting?: boolean;
  }) => void;
}

type Props = OwnProps & StateProps & DispatchProps;

const InstanceObservabilityModalFooter = ({
  instanceUuid,
  onClose,
  instanceObservability,
  getInstanceObservabilityRequest: fetchObservability,
}: Props) => {
  const { loading } = instanceObservability;

  const handleRefresh = () => {
    if (instanceUuid) {
      fetchObservability({ instanceUuid, preserveExisting: true });
    }
  };

  return (
    <Grid>
      <AppButton
        submitButton
        id="observability-refresh-button"
        onClick={handleRefresh}
        disabled={loading}
        isLoading={loading}
      >
        {i18n.t('INSTANCE_OBSERVABILITY.REFRESH')}
      </AppButton>
      <AppButton
        id="observability-close-button"
        variant="outlined"
        onClick={onClose}
      >
        {i18n.t('CLOSE_KEY')}
      </AppButton>
    </Grid>
  );
};

const mapStateToProps = ({
  environments: { instanceObservability },
}: ApplicationState): StateProps => ({
  instanceObservability,
});

export default connect(mapStateToProps, { getInstanceObservabilityRequest })(
  InstanceObservabilityModalFooter
);
